import React from 'react';
import { Link } from 'react-router-dom';
import { breakpoints } from '@/layouts/breakpoints'
import styled  from 'styled-components';
import { ChevronRight } from 'lucide-react';
import LazyVideo from '@/components/landing/common/LazyVideo'


const StyledComp = styled.div`
  padding: 40px;

  @media (max-width: ${breakpoints.medium}) {
    padding: 20px;
  }

  .head{
    font-size: 32px;
    padding: 20px 0;
    border-bottom: 1px solid rgba(var(--greyr), 0.3);

    @media (max-width: ${breakpoints.medium}) {
      font-size: 24px;
    }
  }
  .body{
    padding: 20px 0;
    display: flex;
    flex-direction: row;

    @media (max-width: ${breakpoints.large}) {
      flex-direction: column;
    }

    .left{
      width: 60%;
      position: relative;

      .vid > div{

        z-index: -1;
        position: absolute;
        width: auto;
        height: 140%;
        top: 25px;
        right: 50px;
        overflow: hidden;

        video{
          filter: invert(1);
          width: 102%;
          height: 100%;
        }
      }

      @media (max-width: ${breakpoints.large}) {
        width: 100%;
        min-height: 350px;

        .vid{
          top: 0;
          right: 0;

        }
      }

      @media (max-width: ${breakpoints.small}) {
        min-height: 550px;
      }
      a{
        display: inline;
        flex-direction: row;
        vertical-align: middle;
        transition-duration: 0.3s;
        border-radius: 8px;
        padding: 12px 20px;
        background-color: #eee;
        opacity: 0.8;

        svg{
          transition-duration: 0.3s;
          vertical-align: middle;
        }

        &:hover{
          svg{
            transform: translateX(2px);
          }
          opacity: 1;
        }



      }
      p{
        padding: 20px 0;
        line-height: 1.4;
        width: 60%;
        margin-bottom: 20px;

        @media (max-width: ${breakpoints.large}) {
          width: 100%;
        }
      }
    }
    .right{
      width: 40%;
      padding-top: 40px;

      @media (max-width: ${breakpoints.large}) {
        width: 100%;
        padding-top: 20px;
      }

      .item{
        padding-bottom: 80px;

        @media (max-width: ${breakpoints.medium}) {
          padding-bottom: 40px;
        }

        p{
          line-height: 1.4;
          width: 80%;
          font-size: 12px;
          color: var(--grey);

          @media (max-width: ${breakpoints.large}) {
            width: 100%;
          }
        }
        h4{
          padding-bottom: 20px;
          font-size: 24px;

          @media (max-width: ${breakpoints.medium}) {
            font-size: 20px;
          }

          span{
            font-size: 26px;

            @media (max-width: ${breakpoints.medium}) {
              font-size: 22px;
            }
          }
        }
      }
    }

   }

`;

const Comp = ({}) => {
  return (
    <StyledComp>
      <div className="head">
        <h3 className="sans"> TOO MANY SYSTEMS</h3>
        <h3 className="serif"> TOO LITTLE STRATEGY</h3>
      </div>
      <div className="body">
        <div className="left">
          <p> Stop stitching together APIs, cleaning messy CSVs, and managing endless data vendors. Your competitive edge shouldn't be spent on infrastructure. Axion delivers global pricing, fundamentals, and proprietary alternative data through one unified platform and a single financial data API, so you can focus on what matters: finding alpha. </p>
          <Link to="/dashboard">
            Start in minutes <ChevronRight width={18}/>
          </Link>
          <div className="vid">
            <LazyVideo
              src={'https://cdn.studio14a.com/axion/helix2.mp4'}
            />
          </div>
        </div>

        <div className="right">
          <div className="item">
            <h4 className="sans">CRUSHED BY <span className="serif"> DATA </span> </h4>
            <p> You have access to more information than ever, but turning raw feeds into a clean, structured edge is a full-time job. Our financial intelligence API does the heavy lifting: normalization, deduplication, and time-alignment are built-in. Get market-ready datasets, not data headaches. </p>
          </div>

          <div className="item">
            <h4 className="sans">TIME KILLS <span className="serif"> STRATEGY </span> </h4>
            <p> The market moves fast. Backtesting windows don't wait. If you're spending weeks just sourcing and validating data, your opportunity is gone. With Axion, go from idea to insight in minutes, not months. Rapid iteration is the new edge. </p>
          </div>

          <div className="item">
            <h4 className="sans">SPEED BEATS <span className="serif"> RISK </span> </h4>
            <p> In long-horizon research, the edge is depth. Decades of daily and hourly data, back to 1987, retrievable nearly instantly. Axion's depth-first platform gives you full historical context, so you can backtest ideas against the entire history before committing capital. </p>
          </div>
        </div>
      </div>
    </StyledComp>

  );
};

export default Comp;
